var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-doctor"},[_c('p',{staticClass:"doctor-title"},[_vm._v("医生专属二维码")]),_c('div',{staticClass:"qrcode-box"},[_c('img',{attrs:{"src":_vm.code,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }